import { Event } from "./events"

export class Round {
    public events: Event[]
    public minEnergy: number
    public ended: boolean
    public day: number
    constructor(events: Event[], minEnergy: number) {
        this.events = events
        this.minEnergy = minEnergy
        this.ended = false
        this.day = 1
    }

    public addEvent(event: Event) {
        this.events.push(event)
    }

    public endRound() {
        this.ended = true
    }
}
